module.exports = __webpack_public_path__ + "static/media/selector.4104cae5.svg";